import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatPrice(price: number): string {
  return `¥${price}`
}

export function formatTime(time: string): string {
  return time
}

function getChinaDate(date: Date = new Date()): Date {
  const utcTime = date.getTime() + date.getTimezoneOffset() * 60000
  return new Date(utcTime + 8 * 3600000)
}

export function formatDate(date: string): string {
  const d = getChinaDate(new Date(date))
  const today = getChinaDate()
  const tomorrow = getChinaDate()
  tomorrow.setDate(tomorrow.getDate() + 1)
  
  if (d.toDateString() === today.toDateString()) {
    return '今天'
  } else if (d.toDateString() === tomorrow.toDateString()) {
    return '明天'
  }
  
  const weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
  return `${d.getMonth() + 1}月${d.getDate()}日 ${weekdays[d.getDay()]}`
}

export function formatDateTime(date: string, time: string): string {
  return `${formatDate(date)} ${formatTime(time)}`
}

export function formatDateToLocal(date: Date): string {
  const chinaDate = getChinaDate(date)
  const year = chinaDate.getFullYear()
  const month = String(chinaDate.getMonth() + 1).padStart(2, '0')
  const day = String(chinaDate.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function getWeekDays(startDate: Date = new Date()): Date[] {
  const days: Date[] = []
  const start = getChinaDate(startDate)
  start.setHours(0, 0, 0, 0)
  
  for (let i = 0; i < 7; i++) {
    const day = new Date(start)
    day.setDate(start.getDate() + i)
    days.push(day)
  }
  
  return days
}
